module.exports = __webpack_public_path__ + "static/media/CAMARONSALP_MENU-normal.600435d6.png";